const separator = 'GRDELIMITER';
export const split = (values) => values.split(separator);
export const join = (values) => values.join(separator);